import React from 'react';
import { FaInstagram, FaWhatsapp } from 'react-icons/fa';
import Icon from '../../utils/Icon';
import {
  SocialWrapper,
  CardsRow,
  ContactCard,
  CardIcon,
  CardTitle,
  CardHandle,
  CTASection,
  CTAText,
  CTASubtext,
  WhatsAppButton,
} from './styles';

const SocialLinks: React.FC = () => {
  return (
    <SocialWrapper>
      <CardsRow>
        <ContactCard
          href="https://www.instagram.com/vivibalasartesanais"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Seguir no Instagram"
        >
          <CardIcon $color="#E1306C">
            <Icon icon={FaInstagram} />
          </CardIcon>
          <CardTitle>Instagram</CardTitle>
          <CardHandle>@vivibalasartesanais</CardHandle>
        </ContactCard>

        <ContactCard
          href="https://wa.me/5532988583597"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Conversar pelo WhatsApp"
        >
          <CardIcon $color="#25D366">
            <Icon icon={FaWhatsapp} />
          </CardIcon>
          <CardTitle>WhatsApp</CardTitle>
          <CardHandle>(32) 98858-3597</CardHandle>
        </ContactCard>
      </CardsRow>

      <CTASection>
        <CTAText>Pronto para experimentar nossos doces?</CTAText>
        <CTASubtext>Faça seu pedido agora mesmo pelo WhatsApp</CTASubtext>
        <WhatsAppButton
          href="https://wa.me/5532988583597"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Fazer pedido pelo WhatsApp"
        >
          <Icon icon={FaWhatsapp} />
          Fazer Pedido Agora
        </WhatsAppButton>
      </CTASection>
    </SocialWrapper>
  );
};

export default SocialLinks;

